// extracted by mini-css-extract-plugin
export default {"homeButton":"WaterFall_homeButton__UlHOl","mapButton":"WaterFall_mapButton__4i4mm","button":"WaterFall_button__ziEN6"};